<template>
  <b-modal v-model="visible" title="Ingrese el nuevo mail del tomador">
    <b-form-group>
      <b-input-group size="lg" prepend="@">
        <b-form-input
          type="email"
          v-model="tomador.email"
          @blur="$v.tomador.email.$touch"
          :state="$v.tomador.email.$dirty ? !$v.tomador.email.$error : null"
        ></b-form-input>
      </b-input-group>
    </b-form-group>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          class="float-right"
          @click="submit"
          :disabled="$v.tomador.email.$invalid"
        >
          Aceptar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
export default {
    props: ['tomador', 'nroPoliza'],
    data() {
        return {
            visible: false
        }
    },
    validations: {
        tomador: {
            email: { required, email }
        }
    },
    methods: {
        toggle() {
            this.visible = !this.visible
        },
        submit() {
            this.$v.tomador.$touch();

            if (this.$v.tomador.$invalid) {
                return null;
            }

            this.visible = false;
            return this.$api.post('tomador/cambio-mail/' + this.$route.params.cod_tomador, {
                email: this.tomador.email,
                poliza: this.nroPoliza,
                pas_nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
                pas_cod: this.$store.state.auth.cod_agente,
                pas_email: this.$store.state.auth.email
            }).then(() => {
                this.$toast.success('Se he enviado solicitud de cambio de email del tomador.')
            }).catch(err => {
                this.$toast.error('Ocurrió un error al enviar la solicitud por cambio de email');
                //console.log(err.response)
            })
        }
    }
}
</script>
